/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').directive('designerComponent', [
    function () {
      return {
        templateNamespace: 'svg',
        restrict: 'E',
        // eslint-disable-next-line global-require
        template: require('./designer-component.html'),
        replace: true,
        link(scope, element, attrs) {
          scope.component.setElement(element);

          scope.$on('$destroy', function () {
            scope.component.destroy();
          });
        },
      };
    },
  ]);
})(window.angular);
